import { getMissingInfo } from './states';

export const services = {
  getMissingInfo,
};
